import { createContext } from 'react';

export const SchedulingContextSelector = createContext({});

export const SchedulingContextDispatcher = createContext({});
